import React from 'react';
import { SEAT_COLORS, SEAT_LEGEND } from './seatPalette';

// Kotak warna digambar dengan CSS memakai nilai yang sama persis dengan yang
// dipakai denah — sebelumnya legenda memakai empat file PNG terpisah, yang
// berarti warnanya bisa berbeda dari kursi sungguhan tanpa ada yang sadar.
const SeatLegend = () => (
  <ul className="seat-legend">
    {SEAT_LEGEND.map(({ key, label }) => (
      <li key={key}>
        <span
          className="seat-legend-swatch"
          style={{ backgroundColor: SEAT_COLORS[key] }}
          aria-hidden="true"
        />
        <span>{label}</span>
      </li>
    ))}
  </ul>
);

export default SeatLegend;
